import Vue from 'vue'
import {AppBuildsResource, getWithPagination} from '../../util/api'

const initialState = {
  objects: {},
  createdObject: null, // The most recent Object to be created
  updatedObject: null, // The most recent Object to be updatd
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

export default {
  state: { ...initialState },
  mutations: {
    SET_APP_BUILDS (state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if (objects[key].deleted_at === null) {
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
          }
        }
      }
      state.objects = {
        ...state.objects,
        ...updatedObjects
      }
    },
    SET_APP_BUILD (state, object) {
      if (object.deleted_at === null) {
        Vue.set(state.objects, object.id, object)
      } else {
        Vue.delete(state.objects, object.id)
      }
    },
    CREATED_APP_BUILD (state, object) {
      state.createdObject = object
    },
    UPDATED_APP_BUILD (state, object) {
      state.updatedObject = object
    },

    // Progress States
    GET_APP_BUILD_IN_PROGRESS (state, value) {
      state.getInProgress = value
    },
    CREATE_APP_BUILD_IN_PROGRESS (state, value) {
      state.createInProgress = value
    },
    UPDATE_APP_BUILD_IN_PROGRESS (state, value) {
      state.updateInProgress = value
    },
    DELETE_APP_BUILD_IN_PROGRESS (state, value) {
      state.deleteInProgress = value
    },

    APP_BUILDS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },

  actions: {
    getAppBuild ({ commit }, id) {
      // Check if we have an up-to-date version of the object. If not, get it.
      try {
        AppBuildsResource.get({id: id}).then((response) => {
          commit('SET_APP_BUILD', response.body)
        }, () => {
          // @TODO: Implement error handling
        })
      } catch (ex) {
        // Request was most likely cancelled due to existing in flight request
      }
    },

    getAppBuilds ({ commit }, params) {
      getWithPagination(AppBuildsResource, params, response => {
        // Note: Pagination requests return the objects under the 'data' key
        commit('SET_APP_BUILDS', response.body.data)
      }, () => {
        // Completion handler
      }, () => {
        // Error handler
      })
    },

    createAppBuild ({ commit }, object) {
      // Create (POST) a APP_BUILD
      commit('CREATED_APP_BUILD', null)
      commit('CREATE_APP_BUILD_IN_PROGRESS', true)
      AppBuildsResource.save({}, object).then((response) => {
        commit('CREATE_APP_BUILD_IN_PROGRESS', false)
        commit('CREATED_APP_BUILD', response.body)
        commit('SET_APP_BUILD', response.body)
      }, () => {
        console.error('Create APP_BUILD Failed')
        commit('CREATE_APP_BUILD_IN_PROGRESS', false)
        commit('CREATED_APP_BUILD', null)
      })
    },

    updateAppBuild ({ commit }, object) {
      // Update (PUT) a APP_BUILD
      commit('UPDATED_APP_BUILD', null)
      commit('UPDATE_APP_BUILD_IN_PROGRESS', true)
      AppBuildsResource.update({id: object.id}, object).then((response) => {
        commit('UPDATE_APP_BUILD_IN_PROGRESS', false)
        commit('UPDATED_APP_BUILD', response.body)
        commit('SET_APP_BUILD', response.body)
      }, () => {
        commit('UPDATE_APP_BUILD_IN_PROGRESS', false)
        commit('UPDATED_APP_BUILD', null)
      })
    },

    clearAll ({ commit }) {
      commit('APP_BUILDS_CLEAR_ALL')
    }
  }
}
